import { GameResult } from '@/datamodel/game-result'
import { ResponseData } from '@/datamodel/response-data'
import { PopAlertModel } from '@/datamodel/types'
import { BaccaratBetParams } from '@/datamodel/urlparams/BaccaratBetParams'
import { BetError, BET_TYPE, EventBuss, RESULT } from '@/utils/constants'
import audioPlayer, { SOUNDKEY } from '@/utils/sounds'
import { Options } from 'vue-class-component'
import { Mixins, Prop } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { BetViewBaseMixin } from './bet-view-mixin'
import { DeskOtherInfos, MemberLimit, Table } from 'vue'
import { saveBet } from '@/api'

@Options({})
export class BaccaratBetViewMixin extends Mixins(BetViewBaseMixin) {
    redPairTemp = 0
    bluePairTemp = 0
    super6Temp = 0
    redSuper6Temp = 0

    redConfirmedTemp = 0
    blueConfirmedTemp = 0
    greenConfirmedTemp = 0
    redPairConfirmedTemp = 0
    bluePairConfrimedTemp = 0
    super6ConfimedTemp = 0
    redSuper6ConfirmedTemp = 0

    dragonSevenTemp = 0
    bearEightTemp = 0
    bigTigerTemp = 0
    smallTigerTemp = 0

    dragonSevenConfirmedTemp = 0
    bearEightConfirmedTemp = 0
    bigTigerConfirmedTemp = 0
    smallTigerConfirmedTemp = 0

    isRedPair = false
    isBluePair = false
    isSuper6 = false
    mWin = -1

    testAmount = 1000

    showMessage = false
    message = ''

    @Getter('deskLimit') deskLimit!: MemberLimit
    @Getter('token') token!: string
    @Getter('memberId') memberId!: number
    @Getter('currentDesk') currentDesk!: Table

    @Prop({ default: 0 }) redPairConfirmed!: number
    @Prop({ default: 0 }) bluePairConfirmed!: number
    @Prop({ default: false }) s6Mode!: boolean
    @Prop({ default: 0 }) super6Confirmed!: number
    @Prop({ default: 0 }) redSuper6Confimed!: number

    @Prop({ default: 0 }) dragonSevenConfirmed!: number
    @Prop({ default: 0 }) bearEightConfirmed!: number
    @Prop({ default: 0 }) bigTigerConfirmed!: number
    @Prop({ default: 0 }) smallTigerConfirmed!: number

    @Prop({ default: 0 }) juNo!: number

    @Prop({ default: undefined }) deskOtherInfos!: DeskOtherInfos
    // @Prop({default:false})

    @Action('placeBaccaratBet') placeBaccaratBet!: (
        model: BaccaratBetParams
    ) => Promise<ResponseData>

    OnPlaceBet(betType: number): void {
        console.log('OnPlaceBet', betType, this.chipValue)
        if (this.chipValue <= 0) return

        const toBetAmount = Math.floor(this.CheckIfValidBet(this.chipValue))

        if (toBetAmount > 0) {
            switch (betType) {
                case BET_TYPE.BANKER: {
                    // this.redTemp += toBetAmount

                    const _rTotalR =
                        this.redTemp + this.redConfirmed + toBetAmount
                    const _bTotalR = this.blueTemp + this.blueConfrimed

                    const _maxR = this.deskLimit.upLimit || 0

                    if (Math.abs(_rTotalR - _bTotalR) > _maxR) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)

                        // this.redTemp = _bTotalR + _maxR
                        // celseonsole.log(this.redTemp)
                    } else {
                        this.redTemp += toBetAmount
                    }

                    if (this.redTemp > 0) this.selectedBetArea = betType

                    break
                }
                case BET_TYPE.PLAYER: {
                    // this.blueTemp += toBetAmount

                    //   const _rS6Total_s6 =
                    //     this.redSuper6Temp +
                    //     this.redSuper6Confimed +
                    //     this.redSuper6ConfirmedTemp +
                    //     toBetAmount

                    // const _rTotalB = this.redTemp + this.redConfirmed
                    let _rTotalB = 0

                    if (this.s6Mode) {
                        _rTotalB =
                            this.redSuper6Temp +
                            this.redSuper6Confimed +
                            this.redSuper6ConfirmedTemp
                    } else {
                        _rTotalB = this.redTemp + this.redConfirmed
                    }

                    const _bTotalB =
                        this.blueTemp + this.blueConfrimed + toBetAmount

                    const _maxB = this.deskLimit.upLimit || 0

                    if (Math.abs(_rTotalB - _bTotalB) > _maxB) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)

                        // this.blueTemp = _rTotalB + _maxB
                        // console.log(this.blueTemp)
                    } else {
                        this.blueTemp += toBetAmount
                    }

                    if (this.blueTemp > 0) this.selectedBetArea = betType
                    break
                }
                case BET_TYPE.BC_TIE: {
                    this.greenTemp += toBetAmount

                    const _gTotal =
                        this.greenTemp +
                        this.greenConfrimed +
                        this.greenConfirmedTemp
                    const _gMax = this.deskLimit.tieUpLimit || 0

                    if (_gTotal > _gMax) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)
                        this.greenTemp =
                            _gMax -
                            this.greenConfirmedTemp -
                            this.greenConfrimed
                    }

                    if (this.greenTemp > 0) this.selectedBetArea = betType
                    break
                }
                case BET_TYPE.PLAYER_PAIR: {
                    this.bluePairTemp += toBetAmount

                    const _bPTotalConfirmed =
                        this.bluePairConfirmed + this.bluePairConfrimedTemp
                    const _rPTotalConfirmed =
                        this.redPairConfirmed + this.redPairConfirmedTemp

                    const _totalPTemp = this.redPairTemp + this.bluePairTemp

                    const _sPAllTotal =
                        _bPTotalConfirmed + _rPTotalConfirmed + _totalPTemp
                    const _pairMax = this.deskLimit.pairUpLimit as number

                    if (_sPAllTotal > _pairMax) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)
                        this.bluePairTemp =
                            _pairMax -
                            _bPTotalConfirmed -
                            _rPTotalConfirmed -
                            this.redPairTemp
                    }

                    if (this.bluePairTemp > 0) this.selectedBetArea = betType

                    break
                }
                case BET_TYPE.BANKER_PAIR: {
                    this.redPairTemp += toBetAmount

                    const _bPTotalConfirmed =
                        this.bluePairConfirmed + this.bluePairConfrimedTemp
                    const _rPTotalConfirmed =
                        this.redPairConfirmed + this.redPairConfirmedTemp

                    const _totalPTemp = this.redPairTemp + this.bluePairTemp

                    const _sPAllTotal =
                        _bPTotalConfirmed + _rPTotalConfirmed + _totalPTemp
                    const _pairMax = this.deskLimit.pairUpLimit as number

                    if (_sPAllTotal > _pairMax) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)
                        this.redPairTemp =
                            _pairMax -
                            _bPTotalConfirmed -
                            _rPTotalConfirmed -
                            this.bluePairTemp
                    }

                    if (this.redPairTemp > 0) this.selectedBetArea = betType

                    break
                }
                case BET_TYPE.SUPER6: {
                    if (this.hasTigerBet) {
                        this.toastCommonError(BetError.SUPER6_TIGER_CONFLICT)
                        break
                    }

                    this.super6Temp += toBetAmount

                    const _s6TotalConfirmed =
                        this.super6Confirmed + this.super6ConfimedTemp
                    const _s6Max = this.deskLimit.tieUpLimit || 0
                    const _s6AllTotal = _s6TotalConfirmed + this.super6Temp

                    if (_s6AllTotal > _s6Max) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)

                        this.super6Temp = _s6Max - _s6TotalConfirmed
                    }

                    if (this.super6Temp > 0) this.selectedBetArea = betType
                    break
                }
                case BET_TYPE.BANKER_SUPER6: {
                    // this.redSuper6Temp += toBetAmount

                    const _rS6Total_s6 =
                        this.redSuper6Temp +
                        this.redSuper6Confimed +
                        this.redSuper6ConfirmedTemp +
                        toBetAmount
                    const _bTotal_s6 =
                        this.blueTemp +
                        this.blueConfrimed +
                        this.blueConfirmedTemp

                    const _max_s6 = this.deskLimit.upLimit || 0

                    if (Math.abs(_rS6Total_s6 - _bTotal_s6) > _max_s6) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)

                        // this.redSuper6Temp = _bTotal_s6 + _max_s6
                    } else {
                        this.redSuper6Temp += toBetAmount
                    }

                    if (this.redSuper6Temp > 0) this.selectedBetArea = betType
                    break
                }
                case BET_TYPE.DRAGON_7: {
                    this.dragonSevenTemp += toBetAmount
                    const _d7Total =
                        this.dragonSevenTemp +
                        this.dragonSevenConfirmed +
                        this.dragonSevenConfirmedTemp
                    const _d7Max = this.deskLimit.dragonSevenUpLimit || 0
                    if (_d7Total > _d7Max) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)
                        this.dragonSevenTemp =
                            _d7Max -
                            this.dragonSevenConfirmed -
                            this.dragonSevenConfirmedTemp
                    }
                    if (this.dragonSevenTemp > 0) this.selectedBetArea = betType
                    break
                }
                case BET_TYPE.BEAR_8: {
                    this.bearEightTemp += toBetAmount
                    const _b8Total =
                        this.bearEightTemp +
                        this.bearEightConfirmed +
                        this.bearEightConfirmedTemp
                    const _b8Max = this.deskLimit.bearEightUpLimit || 0
                    if (_b8Total > _b8Max) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)
                        this.bearEightTemp =
                            _b8Max -
                            this.bearEightConfirmed -
                            this.bearEightConfirmedTemp
                    }
                    if (this.bearEightTemp > 0) this.selectedBetArea = betType
                    break
                }
                case BET_TYPE.BIG_TIGER: {
                    if (this.hasSuper6Bet) {
                        this.toastCommonError(BetError.SUPER6_TIGER_CONFLICT)
                        break
                    }

                    this.bigTigerTemp += toBetAmount
                    const _btTotal =
                        this.bigTigerTemp +
                        this.bigTigerConfirmed +
                        this.bigTigerConfirmedTemp
                    const _btMax = this.deskLimit.bigTigerUpLimit || 0
                    if (_btTotal > _btMax) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)
                        this.bigTigerTemp =
                            _btMax -
                            this.bigTigerConfirmed -
                            this.bigTigerConfirmedTemp
                    }
                    if (this.bigTigerTemp > 0) this.selectedBetArea = betType
                    break
                }
                case BET_TYPE.SMALL_TIGER: {
                    if (this.hasSuper6Bet) {
                        this.toastCommonError(BetError.SUPER6_TIGER_CONFLICT)
                        break
                    }

                    this.smallTigerTemp += toBetAmount
                    const _stTotal =
                        this.smallTigerTemp +
                        this.smallTigerConfirmed +
                        this.smallTigerConfirmedTemp
                    const _stMax = this.deskLimit.smallTigerUpLimit || 0
                    if (_stTotal > _stMax) {
                        this.toastCommonError(BetError.ABOVE_MAXIMUM)
                        this.smallTigerTemp =
                            _stMax -
                            this.smallTigerConfirmed -
                            this.smallTigerConfirmedTemp
                    }
                    if (this.smallTigerTemp > 0) this.selectedBetArea = betType
                    break
                }
            }

            const totalTemp =
                this.redPairTemp +
                this.bluePairTemp +
                this.greenTemp +
                this.redTemp +
                this.blueTemp +
                this.super6Temp +
                this.redSuper6Temp +
                this.dragonSevenTemp +
                this.bearEightTemp +
                this.bigTigerTemp +
                this.smallTigerTemp
            this.$emit('on-bet-change', totalTemp)

            // check again
            // this.CheckIfValidBets()
        }
    }

    toastCommonError(_error: string): void {
        if (this.deskId !== -1) {
            this.PopMessage(_error)
        } else {
            const popError: PopAlertModel = {
                type: 0,
                header: '',
                message: _error,
                color: ''
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
        }
    }

    CheckIfValidBets(): void {
        const popError: PopAlertModel = {
            type: 0,
            header: '',
            message: '',
            color: ''
        }

        let betError = this.checkRedAndBlueLimit()

        if (betError !== BetError.BET_OK) {
            if (this.deskId !== -1) {
                this.PopMessage(betError)
            } else {
                popError.message = betError

                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
            }

            // this.OnCancelBetTemp()
            return
        }

        betError = this.checkGreenLimit()

        if (betError !== BetError.BET_OK) {
            // console.log(betError)
            if (this.deskId !== -1) {
                this.PopMessage(betError)
            } else {
                popError.message = betError
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
            }
            // this.OnCancelBetTemp()
            return
        }

        const bluePairTotal = this.bluePairTemp + this.bluePairConfirmed

        betError = this.checkPairLimit(bluePairTotal, this.bluePairTemp)

        if (betError !== BetError.BET_OK) {
            if (this.deskId !== -1) {
                this.PopMessage(betError)
            } else {
                popError.message = betError
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
            }
            // this.OnCancelBetTemp()
            return
        }

        const redPairTotal = this.redPairTemp + this.redPairConfirmed

        betError = this.checkPairLimit(redPairTotal, this.redPairTemp)

        if (betError !== BetError.BET_OK) {
            if (this.deskId !== -1) {
                this.PopMessage(betError)
            } else {
                popError.message = betError
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
            }
            // this.OnCancelBetTemp()
            return
        }

        betError = this.checkSuper6Limit()
        if (betError !== BetError.BET_OK) {
            if (this.deskId !== -1) {
                this.PopMessage(betError)
            } else {
                popError.message = betError
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
            }
            // this.OnCancelBetTemp()
            return
        }
    }

    OnCancelBetTemp(): void {
        this.redTemp = 0
        this.blueTemp = 0
        this.greenTemp = 0
        this.bluePairTemp = 0
        this.redPairTemp = 0
        this.super6Temp = 0
        this.redSuper6Temp = 0
        this.selectedBetArea = -1
        this.dragonSevenTemp = 0
        this.bearEightTemp = 0
        this.bigTigerTemp = 0
        this.smallTigerTemp = 0

        this.$emit('on-bet-change', 0)
    }

    showResult(deskResult: GameResult | undefined): void {
        if (deskResult) {
            const { whoWin, redpair, bluePair, isSuper6, mWin } = deskResult

            this.mWin = mWin
            // console.log('mWin in baccarat mixin', this.mWin)

            this.isBluePair = bluePair
            this.isRedPair = redpair
            this.isRed = whoWin === RESULT.RED
            this.isBlue = whoWin === RESULT.BLUE
            this.isGreen = whoWin === RESULT.GREEN
            this.isSuper6 = isSuper6
        }
    }

    hideGameResult(): void {
        this.isRedPair = false
        this.isBluePair = false
        this.isRed = false
        this.isGreen = false
        this.isBlue = false
        this.isSuper6 = false
        this.mWin = -1
    }

    CheckIfValidBet(tempBet: number): number {
        const total =
            this.redTemp +
            this.blueTemp +
            this.greenTemp +
            this.redPairTemp +
            this.bluePairTemp +
            this.super6Temp +
            this.bearEightTemp +
            this.dragonSevenTemp +
            this.smallTigerTemp +
            this.bigTigerTemp
        tempBet

        if (total <= this.betCoin) return tempBet
        else {
            if (this.deskId !== -1) {
                this.PopMessage(BetError.BALANCE_SHORT)
            } else {
                const popError: PopAlertModel = {
                    type: 0,
                    header: '',
                    message: BetError.BALANCE_SHORT,
                    color: ''
                }
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
            }

            const finalTemp = this.betCoin - (total - tempBet)
            if (finalTemp > 0) return finalTemp
            return 0
        }
    }

    OnConfirmBet(): void {
        const popError: PopAlertModel = {
            type: 0,
            header: '',
            message: '',
            color: ''
        }

        // let betError = this.checkRedAndBlueLimit()

        // if (betError !== BetError.BET_OK) {
        //     console.log(betError)
        //     if (this.deskId !== -1) {
        //         this.PopMessage(betError)
        //     } else {
        //         popError.message = betError
        //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //         //@ts-ignore
        //         this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
        //     }
        //     return
        // }

        // betError = this.checkGreenLimit()

        // if (betError !== BetError.BET_OK) {
        //     // console.log(betError)
        //     if (this.deskId !== -1) {
        //         this.PopMessage(betError)
        //     } else {
        //         popError.message = betError
        //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //         //@ts-ignore
        //         this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
        //     }
        //     return
        // }

        // const bluePairTotal = this.bluePairTemp + this.bluePairConfirmed

        // betError = this.checkPairLimit(bluePairTotal, this.bluePairTemp)

        // if (betError !== BetError.BET_OK) {
        //     if (this.deskId !== -1) {
        //         this.PopMessage(betError)
        //     } else {
        //         popError.message = betError
        //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //         //@ts-ignore
        //         this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
        //     }
        //     return
        // }

        // const redPairTotal = this.redPairTemp + this.redPairConfirmed

        // betError = this.checkPairLimit(redPairTotal, this.redPairTemp)

        // if (betError !== BetError.BET_OK) {
        //     if (this.deskId !== -1) {
        //         this.PopMessage(betError)
        //     } else {
        //         popError.message = betError
        //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //         //@ts-ignore
        //         this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
        //     }
        //     return
        // }

        // betError = this.checkSuper6Limit()
        // if (betError !== BetError.BET_OK) {
        //     if (this.deskId !== -1) {
        //         this.PopMessage(betError)
        //     } else {
        //         popError.message = betError
        //         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //         //@ts-ignore
        //         this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
        //     }
        //     return
        // }

        // betError =
        // everything is passed here call bet
        this.sendBetRequest()
    }

    checkRedAndBlueLimit(): string {
        const redTotal = this.redTemp + this.redConfirmed
        const blueTotal = this.blueTemp + this.blueConfrimed

        if (
            (redTotal > 0 && redTotal < (this.deskLimit.downLimit as number)) ||
            (blueTotal > 0 && blueTotal < (this.deskLimit.downLimit as number))
        )
            return BetError.BELOW_MINIMUM

        const differenceTotal = Math.abs(redTotal - blueTotal)
        if (differenceTotal > (this.deskLimit.upLimit as number))
            return BetError.ABOVE_MAXIMUM

        return BetError.BET_OK
    }

    checkGreenLimit(): string {
        const greenTotal = this.greenTemp + this.greenConfrimed

        if (
            this.greenTemp > 0 &&
            greenTotal < (this.deskLimit.tieDownLimit as number)
        )
            return BetError.BELOW_MINIMUM

        if (greenTotal > (this.deskLimit.tieUpLimit as number))
            return BetError.ABOVE_MAXIMUM
        return BetError.BET_OK
    }

    checkPairLimit(pairTotalBet: number, pairTemp: number): string {
        const _totalPairConfirmed =
            this.redPairConfirmed + this.bluePairConfirmed
        const _totalPairTemp = this.redPairTemp + this.bluePairTemp

        if (
            pairTemp > 0 &&
            pairTotalBet < (this.deskLimit.pairDownLimit as number)
        )
            return BetError.BELOW_MINIMUM

        if (
            _totalPairConfirmed + _totalPairTemp >
            (this.deskLimit.pairUpLimit as number)
        )
            return BetError.ABOVE_MAXIMUM
        // if (pairTotalBet > (this.tableLimit.PairMaxBet as number))
        //     return BetError.ABOVE_MAXIMUM
        return BetError.BET_OK
    }

    checkSuper6Limit(): string {
        const super6Total = this.super6Temp + this.super6Confirmed

        if (
            this.super6Temp > 0 &&
            super6Total < (this.deskLimit.superSixDownLimit as number)
        )
            return BetError.BELOW_MINIMUM

        if (
            this.super6Temp > 0 &&
            super6Total > (this.deskLimit.superSixUpLimit as number)
        )
            return BetError.ABOVE_MAXIMUM

        return BetError.BET_OK
    }

    checkDragonSevenLimit(): string {
        const dragonSevenTotal =
            this.dragonSevenTemp + this.dragonSevenConfirmed

        if (
            this.dragonSevenTemp > 0 &&
            dragonSevenTotal < (this.deskLimit.dragonSevenDownLimit as number)
        )
            return BetError.BELOW_MINIMUM

        if (
            this.dragonSevenTemp > 0 &&
            dragonSevenTotal > (this.deskLimit.dragonSevenUpLimit as number)
        )
            return BetError.ABOVE_MAXIMUM

        return BetError.BET_OK
    }

    checkBearEightLimit(): string {
        const bearEightTotal = this.bearEightTemp + this.bearEightConfirmed

        if (
            this.bearEightTemp > 0 &&
            bearEightTotal < (this.deskLimit.bearEightDownLimit as number)
        )
            return BetError.BELOW_MINIMUM

        if (
            this.bearEightTemp > 0 &&
            bearEightTotal > (this.deskLimit.bearEightUpLimit as number)
        )
            return BetError.ABOVE_MAXIMUM

        return BetError.BET_OK
    }

    checkBigTigerLimit(): string {
        const bigTigerTotal = this.bigTigerTemp + this.bigTigerConfirmed

        if (
            this.bigTigerTemp > 0 &&
            bigTigerTotal < (this.deskLimit.bigTigerDownLimit as number)
        )
            return BetError.BELOW_MINIMUM

        if (
            this.bigTigerTemp > 0 &&
            bigTigerTotal > (this.deskLimit.bigTigerUpLimit as number)
        )
            return BetError.ABOVE_MAXIMUM

        return BetError.BET_OK
    }

    checkSmallTigerLimit(): string {
        const smallTigerTotal = this.smallTigerTemp + this.smallTigerConfirmed

        if (
            this.smallTigerTemp > 0 &&
            smallTigerTotal < (this.deskLimit.smallTigerDownLimit as number)
        )
            return BetError.BELOW_MINIMUM

        if (
            this.smallTigerTemp > 0 &&
            smallTigerTotal > (this.deskLimit.smallTigerUpLimit as number)
        )
            return BetError.ABOVE_MAXIMUM

        return BetError.BET_OK
    }

    sendBetRequest(): void {
        if (this.hasPendingRequest) return

        this.hasPendingRequest = true
        const popError: PopAlertModel = {
            type: 0,
            header: '',
            message: '',
            color: ''
        }

        let _deskId = -1

        if (this.deskId !== -1) {
            _deskId = this.deskId
        } else {
            _deskId = this.currentDesk.id || 0
        }

        let _shoeNo = -1
        let _juNo = -1
        let _gameNo = ''
        if (this.deskOtherInfos) {
            _shoeNo = this.deskOtherInfos.shoeNo
            _juNo = this.deskOtherInfos.juNo
            _gameNo = this.deskOtherInfos.gameNo
        } else {
            _shoeNo = this.currentDesk.expand.shoeNo || 0
            _juNo = this.currentDesk.expand.juNo || 0
            _gameNo = this.currentDesk.expand.gameNo || ''
        }

        const _params: any = {
            token: this.token,
            memberId: this.memberId,
            shoeNo: _shoeNo,
            juNo: _juNo,
            gameNo: _gameNo,
            tableId: _deskId
        }

        if (!this.s6Mode) {
            if (this.redTemp > 0) _params.zhuang = this.redTemp
            if (this.blueTemp > 0) _params.xian = this.blueTemp
            if (this.greenTemp > 0) _params.he = this.greenTemp
            if (this.redPairTemp > 0) _params.zhuangDui = this.redPairTemp
            if (this.bluePairTemp > 0) _params.xianDui = this.bluePairTemp

            if (this.bearEightTemp > 0) _params.bearEight = this.bearEightTemp
            if (this.dragonSevenTemp > 0)
                _params.dragonSeven = this.dragonSevenTemp
            if (this.bigTigerTemp > 0) _params.bigTiger = this.bigTigerTemp
            if (this.smallTigerTemp > 0)
                _params.smallTiger = this.smallTigerTemp

            if (this.super6Temp > 0) _params.superSix = this.super6Temp
        } else {
            if (this.redSuper6Temp > 0) _params.zhuangFree = this.redSuper6Temp
            if (this.blueTemp > 0) _params.xian = this.blueTemp
            if (this.greenTemp > 0) _params.he = this.greenTemp
            if (this.redPairTemp > 0) _params.zhuangDui = this.redPairTemp
            if (this.bluePairTemp > 0) _params.xianDui = this.bluePairTemp
            if (this.super6Temp > 0) _params.superSix = this.super6Temp

            if (this.bearEightTemp > 0) _params.bearEight = this.bearEightTemp
            if (this.dragonSevenTemp > 0)
                _params.dragonSeven = this.dragonSevenTemp
            if (this.bigTigerTemp > 0) _params.bigTiger = this.bigTigerTemp
            if (this.smallTigerTemp > 0)
                _params.smallTiger = this.smallTigerTemp
        }

        // console.log(this.redSuper6Temp, 'red s6')
        // console.log(this.super6Temp, 's6')
        // console.log(this.redTemp, 'red')

        // console.log(this.s6Mode, 'smode')
        // console.log(_params)

        saveBet(_params)
            .then(r => {
                this.hideLoading()
                if (r.data.status === 200) {
                    audioPlayer.Play(SOUNDKEY.BET_SUCCESS)
                    // 投注失败，重置标志允许再次操作
                    this.hasPendingRequest = false

                    if (this.deskId !== -1) {
                        this.PopMessage('下注成功')
                    } else {
                        popError.message = '下注成功'
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
                    }
                    this.$emit('bet-success')

                    this.onBetSuccess({
                        betFormList: r.data.data.gameTable.expand.betFormList,
                        id: r.data.data.gameTable.id,
                        amount: r.data.data.gameTable.expand.amount
                    })
                    this.OnCancelBetTemp()
                } else {
                    // 投注失败，重置标志允许再次操作
                    this.hasPendingRequest = false
                    if (this.deskId !== -1) {
                        this.PopMessage(r.data.description)
                    } else {
                        popError.message = r.data.description
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
                    }
                }
            })
            .catch(() => {
                this.hasPendingRequest = false
                this.hideLoading()
                popError.message = this.t('propmt.networkerror')
                this.emitter.emit(EventBuss.SHOW_POP_ALERT, popError)
            })
    }

    ResetConfirmedTemp(): void {
        this.redConfirmedTemp = 0
        this.blueConfirmedTemp = 0
        this.greenConfirmedTemp = 0
        this.redPairConfirmedTemp = 0
        this.bluePairConfrimedTemp = 0
        this.redSuper6ConfirmedTemp = 0
        this.super6ConfimedTemp = 0

        this.dragonSevenConfirmedTemp = 0
        this.bearEightConfirmedTemp = 0
        this.bigTigerConfirmedTemp = 0
        this.smallTigerConfirmedTemp = 0
        this.hasPendingRequest = false
    }

    PopMessage(msg: string): void {
        this.message = msg
        this.showMessage = true

        setTimeout(() => {
            this.showMessage = false
            this.message = ''
        }, 1000)
    }

    get redFinal(): number {
        if (this.s6Mode)
            return this.redSuper6Confimed + this.redSuper6ConfirmedTemp
        return this.redConfirmed + this.redConfirmedTemp
    }

    get blueFinal(): number {
        return this.blueConfrimed + this.blueConfirmedTemp
    }

    get greenFinal(): number {
        return this.greenConfrimed + this.greenConfirmedTemp
    }

    get bluePairFinal(): number {
        return this.bluePairConfirmed + this.bluePairConfrimedTemp
    }

    get redPairFinal(): number {
        return this.redPairConfirmed + this.redPairConfirmedTemp
    }

    get super6Final(): number {
        return this.super6Confirmed + this.super6ConfimedTemp
    }

    get dragonSevenFinal(): number {
        return this.dragonSevenConfirmed + this.dragonSevenConfirmedTemp
    }

    get bearEightFinal(): number {
        // console.log(
        //     this.bearEightConfirmed + this.bearEightConfirmedTemp,
        //     'hhh'
        // )
        return this.bearEightConfirmed + this.bearEightConfirmedTemp
    }

    get bigTigerFinal(): number {
        return this.bigTigerConfirmed + this.bigTigerConfirmedTemp
    }

    get smallTigerFinal(): number {
        return this.smallTigerConfirmed + this.smallTigerConfirmedTemp
    }

    get allowBetOnB8andD7(): boolean {
        return this.juNo <= 35
    }
    get allowBetOnBigAndSmallTiger(): boolean {
        return this.juNo <= 35
    }

    get hasSuper6Bet(): boolean {
        return (
            this.super6Temp +
                this.super6Confirmed +
                this.super6ConfimedTemp >
            0
        )
    }

    get hasTigerBet(): boolean {
        return (
            this.bigTigerTemp +
                this.bigTigerConfirmed +
                this.bigTigerConfirmedTemp +
                this.smallTigerTemp +
                this.smallTigerConfirmed +
                this.smallTigerConfirmedTemp >
            0
        )
    }

    get isTigerGrayMode(): boolean {
        return !this.allowBetOnBigAndSmallTiger || this.hasSuper6Bet
    }

    get isSuper6GrayMode(): boolean {
        return this.hasTigerBet
    }

    get tigerGrayModeError(): string {
        if (this.hasSuper6Bet) return BetError.SUPER6_TIGER_CONFLICT
        return ''
    }
}
